export function isDateValid(dateStr) {
  return !isNaN(new Date(dateStr));
}
